import { Autoplay, Navigation } from 'swiper/modules';
import Swiper from 'swiper';

let initPostSlider = () => {

	const postSlider = new Swiper('.ndow-post-slider__slider', {
    modules: [Navigation, Autoplay],
    slidesPerView: 'auto',
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    spaceBetween: 44,
    loop: false,
    navigation: {
      nextEl: '.ndow-post-slider__next',
      prevEl: '.ndow-post-slider__prev',
    },
    breakpoints: {
      1199: {
        spaceBetween: 45
      }
    }
  });

}

document.addEventListener('DOMContentLoaded', initPostSlider);